export const arrayIsNotEmpty = (array) => {
  if (isBlank(array)) return false;
  return array?.length > 0 || false;
};

export const isBlank = (value) => value === undefined || value === null || value === "" || value?.length === 0;

export const isNotAFunction = (input) => typeof input !== 'function'

export const getStatusMessage = (error) => {

  console.error(error)
  console.trace(error)

  const statusCode = error?.response?.status;

  const statusMessages = {
    500: "Internal Server Error: An unexpected error occurred on the server."
  }

  if (statusCode) {
    return statusMessages[statusCode] || error?.response?.data?.message || "An error occurred."
  } else {
    return error?.message || 'An error occured.'
  }

};